var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPractice({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.66 38.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #65afd3;\n        stroke-miterlimit: 10;\n        stroke-width: .75px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.23,22.11l.86-1.69c.5-.97.56-2.12.15-3.13-.07-.18-.12-.33-.11-.43.3-6.07,5.64-9.92,11.78-9.99v6.21h-1.1c-.41-.7-1.17-1.16-2.04-1.16-1.31,0-2.37,1.06-2.37,2.37s1.06,2.37,2.37,2.37c.87,0,1.62-.47,2.04-1.17h1.1v6.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.78,16.6c-.76.88-1.59,1.78-2.23,2.3l-2.3-1.38.55-.91c.81,0,1.6-.41,2.05-1.15.67-1.12.31-2.58-.82-3.25-1.12-.67-2.58-.31-3.25.82-.45.75-.43,1.64-.05,2.35l-.55.91-4.51-2.7,3.4-5.68-.94-.56c-.71.39-1.6.4-2.35-.04-1.12-.67-1.49-2.13-.82-3.25.67-1.12,2.13-1.49,3.25-.82.74.45,1.15,1.24,1.15,2.04l.94.56,3.19-5.33c.22.13.43.26.65.4.75.49,1.42,1.05,2.02,1.67.1.09.19.18.29.28,3.7,3.74,3.76,9.74.34,13.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.08,22.53c-1.63,3.1-2.55,5.47-2.06,8.44l.9,5.44c-.01.79-.66,1.43-1.45,1.43h-7.55v-6.67h1.07c.41.7,1.17,1.17,2.04,1.17,1.31,0,2.37-1.06,2.37-2.37s-1.06-2.37-2.37-2.37c-.87,0-1.62.47-2.04,1.16h-1.07v-6.67h5.26v-1.07c-.7-.41-1.16-1.17-1.16-2.04,0-1.31,1.06-2.37,2.37-2.37s2.37,1.06,2.37,2.37c0,.87-.47,1.63-1.17,2.04v1.07h2.69c-.06.16-.12.31-.19.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.92,37.85h-1.58c-.8,0-1.45-.65-1.45-1.45v-1.92c0-.76-.67-1.35-1.42-1.25l-2,.26c-2.03.26-3.82-1.32-3.82-3.36v-2.74c0-.74.14-1.27-.7-1.38l-.85-.11c-1.28,0-2.11-1.36-1.52-2.5l.67-1.3h5.98v1.07c-.7.41-1.16,1.17-1.16,2.04,0,1.31,1.06,2.37,2.37,2.37s2.37-1.06,2.37-2.37c0-.87-.47-1.63-1.17-2.04v-1.07h4.3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPractice);
export default __webpack_public_path__ + "static/media/practice.1c65fb7191b2db204ba65707b0637ed3.svg";
export { ForwardRef as ReactComponent };